import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { AssetContainer } from '~/techstyle-shared/react-assets';
import { mobile } from '~/techstyle-shared/react-components';

const ImageWrapper = styled.div`
  max-width: 800px;
  ${mobile`
    margin: 52px 0;
  `}
`;

const AlternateSizeGuide = ({
  isMens = false,
  isScrubs = false,
  isPets = false,
}) => {
  let assetContainerName = 'FLW_Alternate_Size_Guide';
  if (isPets) {
    assetContainerName = 'FL_Pets_Alternate_Size_Guide';
  } else if (isMens) {
    assetContainerName = 'FLM_Alternate_Size_Guide';
  } else if (isScrubs) {
    assetContainerName = 'FL_Scrubs_Alternate_Size_Guide';
  }

  return (
    <ImageWrapper>
      <AssetContainer name={assetContainerName} />
    </ImageWrapper>
  );
};

AlternateSizeGuide.propTypes = {
  isMens: PropTypes.bool,
  isPets: PropTypes.bool,
  isScrubs: PropTypes.bool,
};

export default AlternateSizeGuide;
